<template>
  <div
    :class="[
      'cms-radio-group',
      { 'cms-radio-group--button': $slots.default }
    ]"
    role="radiogroup"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, provide, watch } from 'vue'
import { radioGroupProps, radioGroupEmits } from './radio-group'
import { radioGroupKey } from './radio'

defineOptions({
  name: 'CmsRadioGroup'
})

const props = defineProps(radioGroupProps)
const emit = defineEmits(radioGroupEmits)

// 内部值
const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(val: string | number | boolean) {
    emit('update:modelValue', val)
    emit('change', val)
  }
})

// 提供给 Radio 组件的上下文
provide(radioGroupKey, {
  name: ref(props.name),
  modelValue,
  disabled: computed(() => props.disabled),
  size: computed(() => props.size),
  onChange: (val: string | number | boolean) => {
    modelValue.value = val
  }
})

// 监听值变化
watch(
  () => props.modelValue,
  (val) => {
    modelValue.value = val
  }
)
</script>

<style>
.cms-radio-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 1;
}

.cms-radio-group--button {
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
}

.cms-radio-group--button .cms-radio-button:first-child .cms-radio-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  box-shadow: none !important;
}

.cms-radio-group--button .cms-radio-button:last-child .cms-radio-button__inner {
  border-radius: 0 4px 4px 0;
}

.cms-radio-group--button .cms-radio-button:first-child:last-child .cms-radio-button__inner {
  border-radius: 4px;
}

.cms-radio-group--button .cms-radio-button--large:first-child .cms-radio-button__inner {
  border-radius: 4px 0 0 4px;
}

.cms-radio-group--button .cms-radio-button--large:last-child .cms-radio-button__inner {
  border-radius: 0 4px 4px 0;
}

.cms-radio-group--button .cms-radio-button--small:first-child .cms-radio-button__inner {
  border-radius: 3px 0 0 3px;
}

.cms-radio-group--button .cms-radio-button--small:last-child .cms-radio-button__inner {
  border-radius: 0 3px 3px 0;
}
</style>